import { DecisionMakerIcon } from '@change/ds-icons/DecisionMakerIcon';
import { HouseIcon } from '@change/ds-icons/HouseIcon';
import { PublicIcon } from '@change/ds-icons/PublicIcon';
import type { Icon } from '@change/ds-icons/types';

type ReachOption = { name: 'global' | 'national' | 'local'; Icon: React.FC<Icon> };
export const REACH_OPTIONS: ReachOption[] = [
	{
		name: 'local',
		Icon: HouseIcon,
	},
	{
		name: 'national',
		Icon: DecisionMakerIcon,
	},
	{
		name: 'global',
		Icon: PublicIcon,
	},
];
